export default __webpack_public_path__ + "static/media/language.27e945d1.svg";